import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=88fee69a&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=88fee69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fee69a",
  null
  
)

export default component.exports